<div
  *ngIf="hasItems"
  class="order-calculations bg-white rounded-lg shadow-md p-4 border border-gray-200 min-w-[300px]"
>
  <div class="border-b border-gray-200 pb-3 mb-3">
    <h3 class="text-lg font-semibold text-gray-900">Order Summary</h3>
    <p class="text-sm text-gray-600">
      {{ totalItems }} item{{ totalItems !== 1 ? 's' : '' }} selected
    </p>
  </div>

  <div class="space-y-2">
    <!-- Tickets Subtotal -->
    <div *ngIf="ticketsSubtotal > 0" class="flex justify-between text-sm">
      <span class="text-gray-600">Tickets Subtotal</span>
      <span class="font-medium">{{
        formatAsDollarFigure(ticketsSubtotal)
      }}</span>
    </div>

    <!-- Products Subtotal -->
    <div *ngIf="addonsTotal > 0" class="flex justify-between text-sm">
      <span class="text-gray-600">Add-ons Subtotal</span>
      <span class="font-medium">{{ formatAsDollarFigure(addonsTotal) }}</span>
    </div>

    <!-- Discount -->
    <div
      *ngIf="discountAmount > 0"
      class="flex justify-between text-sm text-green-600"
    >
      <span>Discount</span>
      <span class="font-medium"
        >-{{ formatAsDollarFigure(discountAmount) }}</span
      >
    </div>

    <!-- Subtotal -->
    <div
      class="flex justify-between text-sm font-medium border-t border-gray-200 pt-2"
    >
      <span class="text-gray-700">Subtotal</span>
      <span>{{ formatAsDollarFigure(totalWithNoFees - discountAmount) }}</span>
    </div>

    <!-- Fees -->
    <div *ngIf="feesTotal > 0" class="space-y-1">
      <div
        *ngIf="totalPlatformFee > 0"
        class="flex justify-between text-sm text-gray-600"
      >
        <span>Platform Fee</span>
        <span>{{ formatAsDollarFigure(totalPlatformFee) }}</span>
      </div>
      <div
        *ngIf="totalVenueFee > 0"
        class="flex justify-between text-sm text-gray-600"
      >
        <span>Venue Fee</span>
        <span>{{ formatAsDollarFigure(totalVenueFee) }}</span>
      </div>
      <div
        *ngIf="totalProcessingFee > 0"
        class="flex justify-between text-sm text-gray-600"
      >
        <span>Processing Fee</span>
        <span>{{ formatAsDollarFigure(totalProcessingFee) }}</span>
      </div>
    </div>

    <!-- Donation -->
    <div
      *ngIf="donationAmount > 0"
      class="flex justify-between text-sm text-blue-600"
    >
      <span>Donation</span>
      <span class="font-medium">{{
        formatAsDollarFigure(donationAmount)
      }}</span>
    </div>

    <!-- Total -->
    <div class="border-t border-gray-200 pt-3">
      <div class="flex justify-between text-lg font-bold text-gray-900">
        <span>Total</span>
        <span>{{ formatAsDollarFigure(amountToPay + donationAmount) }}</span>
      </div>
      <p
        *ngIf="amountToPay === 0 && donationAmount === 0"
        class="text-sm text-green-600 mt-1"
      >
        This order is free!
      </p>
    </div>
  </div>
</div>
